import { FCC } from "@/types/common";
import { Stack, styled, Typography, Link } from "@mui/material";
import { EMPTY_STR } from "@/constants/string";
import Divider from "@mui/material/Divider";
import { black, text } from "@/theme/colors";
import { DATE_FORMAT } from "@/constants/datetime";
import dayjs from "dayjs";

type TMatchInfoItem = {
  label?: string;
  value?: string | null | undefined | number;
  direction?: "row" | "column";
  isShowDivider?: boolean;
  suffix?: string;
  type?: "string" | "date" | "number" | "html" | "textArea";
};

export const MatchInfoItem: FCC<TMatchInfoItem> = ({ label, value, direction, type = "string", suffix, isShowDivider = true }) => {
  const emptyStr = {
    html: EMPTY_STR.TEXT,
    string: EMPTY_STR.TEXT,
    textArea: EMPTY_STR.TEXT,
    date: EMPTY_STR.DATE,
    number: 0,
  };
  const finalValue = {
    string: value,
    html: value,
    textArea: value,
    number: Number(value),
    date: value ? (dayjs(value).isValid() ? dayjs(value).format(DATE_FORMAT) : EMPTY_STR.DATE) : EMPTY_STR.DATE,
  };

  const RenderValue: FCC = ({ children }) => {
    return (
      <Typography
        variant="body14Semi"
        color={text.primary}
        sx={{
          whiteSpace: "normal",
        }}
      >
        {children}
      </Typography>
    );
  };

  const RenderComponent: FCC = ({}) => {
    if (type === "textArea") {
      if (!value) return EMPTY_STR.TEXT;
      const urlRegex = /(https?:\/\/[^\s]+)/g;
      const parts = String(value).split(urlRegex);

      return (
        <pre
          style={{
            wordBreak: "break-word",
            overflowWrap: "break-word",
            whiteSpace: "pre-wrap",
            textWrap: "wrap",
            fontSize: 14,
            fontFamily: "inherit",
          }}
        >
          {parts.map((part, index) =>
            urlRegex.test(part) ? (
              <Link key={index} href={part} target="_blank" rel="noopener noreferrer" underline="none" color="primary">
                {part}
              </Link>
            ) : (
              part
            ),
          )}
        </pre>
      );
    }
    return (
      <RenderValue>
        {value ? finalValue[type] : emptyStr[type]}
        {suffix && value ? suffix : ""}
      </RenderValue>
    );
  };
  return (
    <>
      <MatchInfoItemWrapper direction={direction} gap={1}>
        {label && (
          <Typography variant="cap12" color={black[70]}>
            {label}
          </Typography>
        )}
        <Stack direction="row" justifyContent="space-between">
          <RenderComponent />
        </Stack>
        {isShowDivider && <DividerWrapper />}
      </MatchInfoItemWrapper>
    </>
  );
};

const MatchInfoItemWrapper = styled(Stack)<{ direction?: string }>`
  ${({ direction }) => (direction === "row" ? `align-items: center;` : ``)}
`;

const DividerWrapper = styled(Divider)`
  margin: 16px 0;
  width: 100%;
`;
